import { AxiosInstance } from "axios";
import querystring from "query-string";
import { ApiSearch } from "../../interfaces/Api";
import useAuthenticatedFetch from "../useAuthenticatedFetch";
import { RoleTemplate, NewRoleTemplate } from "./types";

const useRoleTemplates = (query: ApiSearch) => {
  const clearQuery = Object.fromEntries(
    Object.entries(query).filter(([_, v]) => !!v)
  );
  const parsedQuery = querystring.stringify({
    ...clearQuery,
  });

  return useAuthenticatedFetch<{
    total: number;
    roleTemplates: RoleTemplate[];
  }>(`/api/v2/roletemplate?${parsedQuery}`);
};

const useRoleTemplate = (id: number) =>
  useAuthenticatedFetch<NewRoleTemplate>(`/api/v2/roletemplate/${id}`);

const getRoleTemplates = async (
  params: {
    q?: string;
    page?: number;
    pageSize?: number;
    adminType?: string;
    organization?: number | string;
    responsecenter?: string;
    publicArc?: boolean;
    hierarchyUsageToExclude?: number;
  },
  authenticatedRequest: AxiosInstance
) => {
  const settings = querystring.stringify({
    ...params,
  });

  return authenticatedRequest.get<{
    total: number;
    roleTemplates: RoleTemplate[];
  }>(`/api/v2/roletemplate?${settings}`);
};

const deleteRoleTemplate = async (
  id: string | number,
  authenticatedRequest: AxiosInstance
) => authenticatedRequest.delete<{}>(`/api/v2/roletemplate/${id}`);

const createRoleTemplate = async (
  roleModel: NewRoleTemplate,
  authenticatedRequest: AxiosInstance
) =>
  authenticatedRequest.post<NewRoleTemplate>(`/api/v2/roletemplate`, roleModel);

const editRoleTemplate = async (
  id: number,
  roleModel: NewRoleTemplate,
  authenticatedRequest: AxiosInstance
) =>
  authenticatedRequest.put<NewRoleTemplate>(
    `/api/v2/roletemplate/${id}`,
    roleModel
  );

export {
  useRoleTemplates,
  getRoleTemplates,
  deleteRoleTemplate,
  createRoleTemplate,
  useRoleTemplate,
  editRoleTemplate,
};
